const FORM_RECIPIENTS_ROUTES = {
  path: '/form-recipients',
  component: () =>
    import('@/pages/FormRecipients/FormRecipientsPagesContainer.vue'),
  children: [
    {
      path: '',
      name: 'form-recipients.index',
      component: () => import('@/pages/FormRecipients/FormRecipientsPage.vue'),
    },
    {
      path: 'create',
      name: 'form-recipients.create',
      component: () =>
        import('@/pages/FormRecipients/FormRecipientFormPage.vue'),
    },
    {
      path: ':type/editType',
      name: 'form-recipients.editType',
      component: () =>
        import('@/pages/FormRecipients/FormRecipientsTypePage.vue'),
    },
  ],
};

export default FORM_RECIPIENTS_ROUTES;
